import { render, staticRenderFns } from "./PendingUpdate.vue?vue&type=template&id=79f0307e&scoped=true&"
import script from "./PendingUpdate.vue?vue&type=script&lang=js&"
export * from "./PendingUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PendingUpdate.vue?vue&type=style&index=0&id=79f0307e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f0307e",
  null
  
)

export default component.exports